
import echarts from "echarts";
import { Component, Prop, Vue } from "vue-property-decorator";
import { axios, getConfigs, IRequestConfig } from "@/api/appService";

enum DataReportDateType{
  Yearly = 0,
  Monthly = 1
}

@Component({ name: "DataReport" })
export default class DataReport extends Vue {
  @Prop({ default: "get" })
  apiMethod!: string;

  @Prop({ required: true })
  apiUrl!: string;

  @Prop({ required: true })
  title!: string;

  @Prop({required:false})
  dateType?:string;  // yearly, monthly

  @Prop({ default: "year" })
  apiParamNameYear!: string;

  @Prop({ default: "month" })
  apiParamNameMonth!: string;


  @Prop()
  buildApiParameters!: Function;

  @Prop({ required: true })
  buildChartOption!: Function;

  // private members
  year!: number ;
  month!: number;
  elementId: string = "";
  fetchCount: number = 0;

  myChart: any;

  loading: boolean = true;
  dateMonth: string = "";

  created() {
    this.elementId = "echarts-report-" + (Math.random() * 1000000).toFixed(0);

    this.dateMonth = this.year + "-" + this.month;
    const now = new Date();
    if(this.dateType){
      this.year = now.getFullYear();
      this.dateMonth = `${this.year}`;
      if(this.dateType === 'monthly'){
        this.month = now.getMonth()+1;
        this.dateMonth = `${this.year}-${this.month}`;
      }
    } else {
      this.dateMonth = `${now.getFullYear()}-${now.getMonth()+1}`;
    }

  }

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.fetchCount++;
    this.loading = true;
    await this.createApiRequest().then(res => {
      this.renderEChart(res);
      this.loading = false;
    });
  }

  createApiRequest() {
    return new Promise((resolve, reject) => {
      let url = this.apiUrl;
      const configs: IRequestConfig = getConfigs(
        this.apiMethod,
        "application/json",
        url,
        {}
      );
      const yearOption: any = {};
      const monthOption: any = {};
      if(this.dateType === 'yearly'){
        yearOption[this.apiParamNameYear] = this.year;
      } else if(this.dateType === 'monthly'){
        yearOption[this.apiParamNameYear] = this.year;
        monthOption[this.apiParamNameMonth] = this.month;
      }

      let apiParameters: any = {};
      if (!!this.buildApiParameters) {
        apiParameters = this.buildApiParameters(this.year, this.month);
      }
      configs.params = Object.assign({}, yearOption,monthOption, apiParameters);
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

  renderEChart(res: any) {
    if (!this.myChart) {
      // @ts-ignore
      this.myChart = echarts.init(document.getElementById(this.elementId));
    }
    let option = this.buildChartOption(res);
    const chartOption = Object.assign(
      {},
      {
        grid: {
          left: "30px",
          right: "0px",
          top: "10px",
          bottom: "30px"
        }
      },
      option
    );
    this.myChart.setOption(chartOption);
  }

  prevYear() {
    this.year--;
    this.fetchData();
  }

  nextYear() {
    this.year++;
    this.fetchData();
  }

  changeDate(e:any) {
    const newDate = new Date(this.dateMonth);
    this.year = newDate.getFullYear();
    if(this.dateType === 'monthly'){
      this.month = newDate.getMonth() + 1;
    }
    this.fetchData();
  }
}
